import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Checkbox Button Atom Component
 *
 * Reusable checkbox button with blue-deep border and rounded styling.
 * Used in filter sidebar and other places requiring checkbox selections.
 */
@Component({
  selector: 'app-checkbox-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './checkbox-button.component.html'
})
export class CheckboxButtonComponent {
  /**
   * Label text to display next to the checkbox
   */
  @Input() label = '';

  /**
   * Checked state of the checkbox
   */
  @Input() checked = false;

  /**
   * Event emitted when checkbox state changes
   * Emits the new checked state (true/false)
   */
  @Output() checkedChange = new EventEmitter<boolean>();

  /**
   * Handle checkbox change event
   */
  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checkedChange.emit(target.checked);
  }
}
